import { Action, createReducer, on } from '@ngrx/store';
import { commonDoctorActions } from './doctor.action';
import { CommonDoctorState, commonDoctorIS } from './doctor.state';

const commonDoctorRegister = createReducer(
  commonDoctorIS,
  on(commonDoctorActions.setResultAction, (state, result) => ({
    ...state,
    result,
  })),

  on(commonDoctorActions.addResultAction, (state, doctor) => ({
    ...state,
    result: {
      ...state.result,
      content: [doctor, ...state.result.content],
      numberOfElements: state.result.numberOfElements + 1,
      totalElements: state.result.totalElements + 1,
    },
  })),

  on(commonDoctorActions.patchResultAction, (state, doctor) => ({
    ...state,
    result: {
      ...state.result,
      content: state.result.content.map((item) => {
        if (item.id === doctor.id) {
          return doctor;
        }
        return item;
      }),
    },
  })),

  on(commonDoctorActions.setDoctorAction, (state, data) => ({
    ...state,
    data,
  })),

  on(commonDoctorActions.setResidenceAction, (state, residence) => ({
    ...state,
    residence,
  })),

  on(commonDoctorActions.setDoctorDefaultAction, (state) => ({
    ...state,
    data: commonDoctorIS.data,
    residence: commonDoctorIS.residence,
  })),

  on(commonDoctorActions.setAllDefaultAction, () => commonDoctorIS)
);

export function commonDoctorReducer(state: CommonDoctorState, action: Action): any {
  return commonDoctorRegister(state, action);
}
